




































import * as analyticHelper from '@/lib/analytic-helper';
import { Component, Prop, Vue, Provide, Watch, Emit, Inject } from 'vue-property-decorator';
import { MenuSearchState, MenuHistoryState } from '../../store';
import { ILookupResult } from '../../store/SearchState/types';
import { namespace } from 'vuex-class';
const menuSearchStore = namespace('MenuSearchState');
const menuHistoryStore = namespace('MenuHistoryState');

@Component({
  name: 'MenuResultsPanel',
  components: {},
})
export default class MenuResultsPanel extends Vue {
  @Prop({ required: false }) public caption: string;
  @Prop({ required: false }) public mode: ("search" | "history");
  @Prop({ required: false }) public show: boolean;

  @menuHistoryStore.Getter('items') historyItems: ILookupResult[];
  @menuHistoryStore.Getter('selectedResultIndex') historySelectedIndex: number;
  @menuHistoryStore.Getter('selectedResult') historySelectedResult: ILookupResult | null;

  @menuSearchStore.Getter('results') searchItems: ILookupResult[];
  @menuSearchStore.Getter('selectedResultIndex') searchSelectedIndex: number;
  @menuSearchStore.Getter('selectedResult') searchSelectedResult: ILookupResult | null;
  @menuSearchStore.Getter('isSearching') searchIsSearching: boolean;

  @menuHistoryStore.Action('add') addItemToHistory: (item: ILookupResult) => void;
  @menuHistoryStore.Action('selectNextResult') historyDown: () => void;
  @menuHistoryStore.Action('selectPreviousResult') historyUp: () => void;
  @menuHistoryStore.Action('load') loadHistory: () => void;

  @menuSearchStore.Action('lookup') search: (text: string) => void;
  @menuSearchStore.Action('selectPreviousResult') searchUp: () => void;
  @menuSearchStore.Action('selectNextResult') searchDown: () => void;

  @Inject('searchText') public searchTextInjector: () => string;
  public get searchText() { return this.searchTextInjector(); }

  @Watch('searchText')
  onSearchText(value: string, oldValue: string) {
    if (this.mode === 'history') {return;}
    if (!this.show) {return;}
    this.search(value);
  }
  @Watch('show')
  onShow(value: boolean, oldValue: boolean) {
    if (this.mode === 'history') {return;}
    if (!value) {return;}
    this.search(this.searchText);
  }
  @Emit('navigate') public navigate(e: Event) { return e; }
  public get selectedResult(): ILookupResult | null {
    if (this.mode === 'search') {
      return this.searchSelectedResult;
    }
    if (this.mode === 'history') {
      return this.historySelectedResult;
    }
    return null;
  }
  public get selectedIndex(): number {
    if (this.mode === 'search') {
      return this.searchSelectedIndex;
    }
    if (this.mode === 'history') {
      return this.historySelectedIndex;
    }
    return 0;
  }

public get isSearching(): boolean {
      return this.searchIsSearching;
  }
  public get items(): ILookupResult[] {
    if (this.mode === 'search') {
      return this.searchItems;
    }
    if (this.mode === 'history') {
      return this.historyItems;
    }
    return [];
  }

  public beforeMount() {
    const parentVueNode = this.$parent?.$parent;
    if (parentVueNode?.$el?.classList?.contains('ax-searchbar')) {
      parentVueNode.$off('onUpKeyPressedInSearchbox', this.onUpKeyPressedInSearchbox);
      parentVueNode.$off('onDownKeyPressedInSearchbox', this.onDownKeyPressedInSearchbox);
      parentVueNode.$off('actionOnSelectedItem', this.actionOnSelectedItem);
      parentVueNode.$on('onUpKeyPressedInSearchbox', this.onUpKeyPressedInSearchbox);
      parentVueNode.$on('onDownKeyPressedInSearchbox', this.onDownKeyPressedInSearchbox);
      parentVueNode.$on('actionOnSelectedItem', this.actionOnSelectedItem);
    }
    this.loadHistory();
  }

  public beforeUnmount() {
    const parentVueNode = this.$parent?.$parent;
    if (parentVueNode?.$el?.classList?.contains('ax-searchbar')) {
      parentVueNode.$off('onUpKeyPressedInSearchbox', this.onUpKeyPressedInSearchbox);
      parentVueNode.$off('onDownKeyPressedInSearchbox', this.onDownKeyPressedInSearchbox);
      parentVueNode.$off('actionOnSelectedItem', this.actionOnSelectedItem);
    }
  }

  public onUpKeyPressedInSearchbox() {
    if (!this.show) {return;}
    if (this.mode === 'history') {this.historyUp();}
    if (this.mode === 'search') {this.searchUp();}
  }
  public onDownKeyPressedInSearchbox() {
    if (!this.show) {return;}
    if (this.mode === 'history') {this.historyDown();}
    if (this.mode === 'search') {this.searchDown();}
  }

  public actionOnSelectedItem() {
    if (!this.show) {return;}
    const selectedResult = this.selectedResult;
    if (!selectedResult) {return;}
    analyticHelper.powerbarSearchItemActivatedEvent({
      label: selectedResult.label,
      target: selectedResult.target,
      href: selectedResult.href,
      modal: selectedResult.modal,
    });
    if (selectedResult.modal) {
      const anchor = document.createElement('A') as HTMLAnchorElement;
      anchor.href = selectedResult.href;
      anchor.target = selectedResult.target;
      anchor.classList.add('sip-modal', 'sip-link');
      const that = this;
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        that.navigate(e);
      });
      anchor.click();
    } else {
      const { href, target } = selectedResult;
      window.open(href, target);
    }
  }
  public beforeCreate() {
    MenuSearchState.register?.(this.$store);
    MenuHistoryState.register?.(this.$store);
  }
  public destroyed() {
    MenuSearchState.unregister?.(this.$store);
    MenuHistoryState.unregister?.(this.$store);
  }
  public itemClassForIndex(index: number) {
    return { selected: index === this.selectedIndex };
  }
  public itemLabelHtml(item: ILookupResult) {
    return item.label.replace(
      new RegExp(this.searchText, 'gi'),
      match => `<span style="background-color: rgba(255,255,255,0.2);">${match}</span>`);
  }
  navigateAction(e: Event, item: ILookupResult) {
    this.addItemToHistory(item);
    analyticHelper.powerbarSearchItemActivatedEvent({
      label: item.label,
      target: item.target||'',
      href: item.href,
      modal: item.modal,
    });
    if (!!item.modal) {
      e.preventDefault();
    }
    if ((e.target as Element)?.classList?.contains('ax-icon--pop-out') ||
        (e.target as Element)?.parentElement?.classList?.contains('popout')) {
      e.stopPropagation();
    }
    this.navigate(e);
  }
}
